<template>
  <Layout style="height: 100%" class="main menu-wrapper">
    <Sider
      v-model.trim="collapsed"
      :width="250"
      :collapsed-width="64"
      :style="{ overflow: 'hidden' }"
      hide-trigger
      collapsible
      class="left-sider"
    >
      <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
      <div v-show="!collapsed" class="title ivu-menu-dark menu-title">
        <div class="logo-con-home"></div>
        <!-- <img style="width: 79px" src="../../assets/images/logo7.png" /> -->
        <!-- <h3 ref="subTitle" class="sub-title">
          {{ title }}
        </h3> -->
        <h3
          ref="subTitle"
          class="sub-title"
          :class="{ 'black-text': userInfo.orgtype === '培才' }"
        >
          {{ title }}
        </h3>
        <div>
          <Input
            v-show="!collapsed"
            prefix="ios-search"
            v-model.trim="SearchText"
            placeholder="请输入要搜索菜单栏"
            size="large"
            clearable
            class="menuSearchInput"
            @on-change="searchTreeData(SearchText)"
            style="width: 220px"
          />
        </div>
      </div>
      <div class="menu-list-container">
        <side-menu
          ref="sideMenu"
          :active-name="$route.name"
          :collapsed="collapsed"
          :menu-list="menuList"
          :openNames="openNames"
          accordion
          @on-select="turnToPage"
        ></side-menu>
      </div>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar
          :collapsed="collapsed"
          @on-coll-change="handleCollapsedChange"
        >
          <user
            :message-unread-count="unreadCount"
            :user-name="userName"
            :user-avatar="userCode"
          />
          <fullscreen v-model.trim="isFullscreen" style="margin-right: 10px" />
          <!-- <div
            style="
              height: 64px;
              display: flex;
              align-items: center;
              margin-right: 10px;
            "
          >
            <Select v-model="theme" @on-change="changeTheme">
              <Option value="red">红色主题</Option>
              <Option value="blue">蓝色主题</Option>
              <Option value="black">黑色主题</Option>
            </Select>
          </div> -->
          <Tooltip
            :content="mesCount > 0 ? `有${mesCount}条未读消息` : '前往消息中心'"
            placement="bottom"
          >
            <div @click="handleLoadMessage">
              <Badge :count="mesCount" style="margin-right: 10px">
                <i class="iconfont icon-icon_notice-copy"></i>
              </Badge>
              <!-- <el-badge :value="mesCount" class="item">
                <i class="iconfont icon-icon_notice-copy"></i>
              </el-badge> -->
            </div>
            <Drawer
              title="消息中心"
              placement="right"
              v-model="msgShow"
              width="700"
            >
              <div style="display: flex; justify-content: flex-end">
                <Button
                  @click.stop="handelOneClickRead()"
                  size="small"
                  type="primary"
                  :loading="btnLoading"
                >
                  一键已读
                </Button>
              </div>
              <Tabs v-model="readType" @on-click="handleLoadMessage">
                <TabPane :label="'未读(' + noreadCount + ')'" name="false">
                  <div v-if="readType === 'false'">
                    <div
                      v-for="(item, index) in messageList"
                      :key="index"
                      class="msg-box"
                      @click="goToDetail(item)"
                    >
                      <div style="margin-top: unset" v-if="item.title">
                        <span>标题：</span>
                        {{ item.title }}
                      </div>
                      <Time
                        :time="new Date(item.inform_create_time)"
                        style="float: right"
                      ></Time>
                      <div v-if="item.initiator_name">
                        <span>消息发起：</span>
                        {{ item.initiator_name }}
                      </div>
                      <div v-if="item.menucode && item.menucode.menuname">
                        <span>业务：</span>
                        {{ item.menucode.menuname }}
                      </div>
                      <div v-if="item.type_code === 1">
                        <span>业务类型：</span>
                        审批
                      </div>
                      <div v-if="item.type_code === 2">
                        <span>业务类型：</span>
                        转办
                      </div>
                      <div v-if="item.type_code === 3">
                        <span>业务类型：</span>
                        系统通知
                      </div>
                      <div v-if="item.inform_create_time">
                        <span>消息时间：</span>
                        {{ item.inform_create_time }}
                      </div>
                    </div>
                  </div>
                </TabPane>
                <TabPane :label="'近期已读(' + readCount + ')'" name="true">
                  <div v-if="readType === 'true'">
                    <div
                      v-for="(item, index) in messageList"
                      :key="index"
                      class="msg-box"
                      @click="goToDetail(item)"
                    >
                      <div style="margin-top: unset" v-if="item.title">
                        <span>标题：</span>
                        {{ item.title }}
                      </div>
                      <Time
                        :time="new Date(item.inform_create_time)"
                        style="float: right"
                      ></Time>
                      <div v-if="item.initiator_name">
                        <span>消息发起：</span>
                        {{ item.initiator_name }}
                      </div>
                      <div v-if="item.menucode && item.menucode.menuname">
                        <span>业务：</span>
                        {{ item.menucode.menuname }}
                      </div>
                      <div v-if="item.type_code === 1">业务类型：审批</div>
                      <div v-if="item.type_code === 2">业务类型：转办</div>
                      <div v-if="item.type_code === 3">业务类型：系统通知</div>
                      <div
                        v-if="item.inform_create_time"
                        style="
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                      >
                        <div style="margin-top: unset">
                          <span>消息时间：</span>
                          {{ item.inform_create_time }}
                        </div>
                        <Button
                          @click.stop="setMsgNoRead(item)"
                          type="primary"
                          size="small"
                        >
                          设置未读
                        </Button>
                      </div>
                    </div>
                  </div>
                </TabPane>
              </Tabs>
              <Button
                style="margin-top: 10px"
                size="small"
                @click="goToMsgCenter"
                type="default"
              >
                更多
              </Button>
            </Drawer>
          </Tooltip>

          <!-- <Dropdown style="margin-right: 20px">
            <Button>
              OA管理系统
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <template #list>
              <DropdownMenu>
                <DropdownItem @on-click="handleChangeSystemtype('OA管理系统')">
                  OA管理系统
                </DropdownItem>
                <DropdownItem @on-click="handleChangeSystemtype('资产管理')">
                  资产管理
                </DropdownItem>
              </DropdownMenu>
            </template>
          </Dropdown> -->
          <!-- <div
            style="
              height: 64px;
              display: flex;
              align-items: center;
              margin-right: 20px;
            "
          >
            <Select
              v-model="systemtype"
              @on-change="handleChangeSystemtype"
              style="width: 150px"
            >
              <Option
                v-for="(itme, index) in systemtypelist"
                :key="index"
                :value="itme.value"
              >
                {{ itme.text }}
              </Option>
            </Select>
          </div> -->
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav
              :value="$route"
              :list="tagNavList"
              @input="handleClick"
              @on-close="handleCloseTag"
            />
          </div>
          <Content class="content-wrapper">
            <KeepAlive>
              <router-view ref="routerView" />
            </KeepAlive>
            <!-- <keep-alive>
              <router-view v-if="shouldCache" />
            </keep-alive>
            <router-view v-if="!shouldCache" /> -->
            <ABackTop
              :height="100"
              :bottom="25"
              :right="50"
              container=".content-wrapper"
            ></ABackTop>
          </Content>
        </Layout>
      </Content>
    </Layout>
    <!-- AI小O -->
    <!-- <miniChat></miniChat> -->
    <!-- 操作手册 -->
    <procedures :url="currentPageTitle"></procedures>
    <div class="customer-service" @click="handleOpenService">
      <!-- <img :src="require('/assets/service.svg')" /> -->
      <i
        style="color: rgb(255, 255, 255); font-size: 20px"
        class="iconfont icon-weixin-copy"
      ></i>
      <div>联系客服</div>
    </div>
    <Modal v-model="customerServiceModal" title="客服">
      <div class="service-box">
        <div class="service-title">如有问题，请联系人工客服咨询</div>
        <img :src="require('/assets/code.png')" />
        <div
          style="
            margin-top: 3px;
            margin-bottom: 10px;
            color: #515a61;
            line-height: normal;
          "
        >
          请使用微信扫描二维码
        </div>
        <Button
          style="margin-top: 16px"
          class="btn"
          type="success"
          @click="handelOpenWechat"
        >
          联系客服
        </Button>
        <div
          style="
            margin-top: 3px;
            margin-bottom: 10px;
            color: #515a61;
            line-height: normal;
          "
        >
          需电脑已安装并登录上微信客户端
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <!-- 后台导入悬浮任务条 -->
    <ImportTaskFloat />
  </Layout>
</template>
<script>
import SideMenu from './components/side-menu';
import HeaderBar from './components/header-bar';
import TagsNav from './components/tags-nav';
import User from './components/user';
import ABackTop from './components/a-back-top';
import Fullscreen from './components/fullscreen';
import { mapMutations, mapActions, mapState } from 'vuex';
import { getNewTagList, routeEqual } from '@/libs/util';
import routers from '@/router/routers';
import './main.less';
import { getInformList, setIsRead, oneClickRead } from '@/api/user';
import { fetchOptions } from '@/api/dropSelection';
import ImportTaskFloat from '@/components/import-task-float/ImportTaskFloat.vue';
// import {PlatformSelect} from '@/components/platformSelect/index.vue'

export default {
  name: 'layoutMain',
  components: {
    SideMenu,
    HeaderBar,
    TagsNav,
    Fullscreen,
    User,
    ABackTop,
    ImportTaskFloat,
  },
  data() {
    return {
      btnLoading: false, //按钮loding
      customerServiceModal: false,
      messageList: [],
      msgShow: false,
      theme: null,
      mesCount: 0,
      noreadCount: 0,
      readCount: 0,
      collapsed: false,
      isFullscreen: false,
      SearchText: '',
      menuList: this.$store.getters.menuList,
      openNames: [],
      readType: 'false',
      title: 'OA管理系统',
      // 需要缓存的组件名数组
      cachedComponents: [],
      userInfo: [], //用户信息
      systemtypelist: [], //系统类型列表
      systemtype: 'S368', //系统类型
      currentPageTitle: '',
    };
  },
  created() {
    // this.$nextTick(
    //   () =>
    //     (this.$refs.subTitle.innerHTML = 'OA管理系统'),
    // );
    if (this.shouldCache) {
      this.cachedComponents = this.$route.name;
    }
    window.addEventListener('setItem', (e) => {
      this.title = e.newValue;
    });
  },
  activated() {
    try {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
        this.getDelData();
      }
    } catch (error) {}
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    this.systemtype = localStorage.getItem('systemtype') || 'OA管理系统';
    if (this.userInfo.orgtype === '集团') {
      this.title = '湛江寸金教育集团';
    } else if (this.userInfo.orgtype === '湛科') {
      this.title = '湛江科技学院';
    } else if (this.userInfo.orgtype === '培才') {
      this.title = '湛江市寸金培才学校';
    } else {
      this.title = 'OA管理系统';
    }
    this.getSystemtypelist(); //系统类型
    const tmp = {
      page: 1,
      rows: 20,
      pageNo: 1,
      pageSize: 20,
      is_read: false,
    };
    this.getAddInform(tmp); //查询通知
    this.theme = localStorage.getItem('theme') || 'red';
    // this.$nextTick(
    //   () =>
    //     (this.$refs.subTitle.innerHTML = 'OA管理系统'),
    // );

    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.refreshAccess();
    this.setTagNavList();
    this.setHomeRoute(routers);
    const { name, params, query, meta } = this.$route;
    this.addTag({
      route: { name, params, query, meta },
    });
    this.setBreadCrumb(this.$route);
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find((item) => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName,
      });
    }
  },
  computed: {
    // 根据条件判断是否需要缓存当前组件
    shouldCache() {
      // 这里可以根据需要进行条件判断
      // 例如，只缓存特定的路由组件
      return this.$route.meta.keepAlive;
    },
    ...mapState({
      tagNavList: (state) => state.app.tagNavList,
      tagRouter: (state) => state.app.tagRouter,
      userName: (state) => state.user.userName,
      userCode: (state) => state.user.userCode,
      userRole: (state) => state.user.userRole,
    }),
    cacheList() {
      const list = [
        'ParentView',
        ...(this.tagNavList.length
          ? this.tagNavList
              .filter((item) => !(item.meta && item.meta.notCache))
              .map((item) => item.name)
          : []),
      ];
      return list;
    },
    local() {
      return this.$store.state.app.local;
    },
    hasReadErrorPage() {
      return this.$store.state.app.hasReadErrorPage;
    },
    unreadCount() {
      return this.$store.state.user.unreadCount;
    },
  },
  methods: {
    //一键已读
    async handelOneClickRead() {
      this.btnLoading = true;
      const res = await oneClickRead({
        notify_recipient_id: this.userInfo.f_id,
      });
      if (res.data.success) {
        this.btnLoading = false;
        this.$message.success(res.data.msg);
        this.readType = 'true';
        const tmp = {
          page: 1,
          rows: 20,
          pageNo: 1,
          pageSize: 20,
          is_read: true,
        };
        this.getAddInform(tmp); //查询通知
      } else {
        this.btnLoading = false;
        this.$message.error(res.data.msg);
      }
    },
    //查询系统类型
    async getSystemtypelist() {
      const res = await fetchOptions({
        type: '系统类型',
      });
      this.systemtypelist = res.data.data.data;
    },
    //改变系统类型
    handleChangeSystemtype(e) {
      localStorage.setItem('systemtype', e);
      this.$router.push({
        path: '/home',
        query: { foo: 'bar' },
        replace: true,
      });
      location.reload();
      console.log(e, '改变系统类型');
    },
    handelOpenWechat() {
      window.open('https://work.weixin.qq.com/kfid/kfc0ef4d1bd22666d5c');
    },
    //打开客服
    handleOpenService() {
      this.customerServiceModal = true;
    },
    //跳转消息通知列表
    goToMsgCenter() {
      this.$router.push({
        path: '/rfi/messageMgmt',
      });
      this.msgShow = false;
    },
    //设置未读
    async setMsgNoRead(e) {
      const res = await setIsRead({ id: e.id, settingCode: 1 });
      if (res.data.success) {
        this.$message.success(res.data.msg);
        let params = {
          page: 1,
          rows: 20,
          pageNo: 1,
          pageSize: 20,
          is_read: true,
        };
        this.getAddInform(params);
      } else {
        this.$message.error(res.data.msg);
      }
    },
    //跳转详情
    async goToDetail(e) {
      const form_id = e.form_id || e.form_id_int;
      await setIsRead({ id: e.id });
      const tmp = false;
      let params = {
        page: 1,
        rows: 20,
        pageNo: 1,
        pageSize: 20,
        is_read: tmp,
      };
      let routerParms = {
        path: e.menucode.menuurl,
        query: { id: form_id, path: e.menucode.menuurl },
      };
      if (e.form_type === 'oa_pms_task') {
        routerParms = {
          path: '/dmy/pms/taskMgmt/taskMgmtDetails',
          query: { task_id: form_id, path: e.menucode.menuurl },
        };
      }
      this.getAddInform(params);
      // this.$router.push(routerParms);
      if (this.$route.path === routerParms.path) {
        // 如果已经在目标页面，则先导航到一个中间页面
        this.$router.push({ path: '/home' }).then(() => {
          setTimeout(() => {
            // 然后再导航到目标页面
            this.$router.push(routerParms);
          }, 500);
        });
      } else {
        // 如果不在目标页面，则直接导航到目标页面
        this.$router.push(routerParms);
      }
      this.msgShow = false;
    },
    getToday(date) {
      const date1 = new Date(date);
      const date2 = new Date();
      const differenceInTime = date2 - date1;
      const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
      return differenceInDays;
    },
    async getAddInform(params) {
      const res = await getInformList(params);
      if (res.data.success) {
        this.messageList = res.data.data.data;
        this.mesCount = res.data.data.noreadcount;
        this.noreadCount = res.data.data.noreadcount;
        this.readCount = res.data.data.isreadcount;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    //切换主题
    changeTheme(e) {
      localStorage.setItem('theme', e);
      this.$changeTheme();
      // 普通刷新（可能会使用缓存）
      location.reload();
    },
    //点击通知
    async handleLoadMessage() {
      this.msgShow = true;
      const tmp = this.readType === 'true' ? true : false;
      let params = {
        page: 1,
        rows: 20,
        pageNo: 1,
        pageSize: 20,
        is_read: tmp,
      };
      this.getAddInform(params);
    },
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setLocal',
      'setHomeRoute',
      'closeTag',
      'refreshAccess',
    ]),
    ...mapActions([
      'handleLogin',
      'getUnreadMessageCount',
      'handleGetServiceAreaList',
    ]),
    turnToPage(route) {
      let { name, params, query } = {};
      if (typeof route === 'string') name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1]);
        return false;
      }
      this.$router.push({
        name,
        params,
        query,
      });
    },
    handleCollapsedChange(state) {
      this.collapsed = state;
    },
    handleCloseTag(res, type, route) {
      if (type !== 'others') {
        if (type === 'all') {
          this.turnToPage(this.$config.homeName);
        } else {
          if (routeEqual(this.$route, route)) {
            this.closeTag(route);
          }
        }
      }
      this.setTagNavList(res);
    },
    handleClick(item) {
      this.turnToPage(item);
    },
    // 输入框搜索
    searchTreeData(searChText) {
      const alltreeData = this.deepCopyObj(this.$store.getters.menuList);
      this.openNames = [];
      if (!searChText) {
        this.menuList = alltreeData;
        return false;
      }
      const treeArr = this.findSearchText(alltreeData, searChText);
      this.menuList = treeArr;
    },
    // 选择搜索内容
    findSearchText(treeData, searChText) {
      const treeArr = treeData.filter((item) => {
        if (item.meta && item.meta.title.indexOf(searChText) > -1) {
          this.openNames.push(item.name);
          return true;
        }
        if (item.children && item.children.length > 0) {
          const children = this.findSearchText(item.children, searChText);
          if (children.length > 0) {
            item.children = children;
            this.openNames.push(item.name);
            return true;
          }
        }
        return false;
      });
      return treeArr;
    },
    // 深拷贝一个对象
    deepCopyObj(copyObj) {
      const newObj = Array.isArray(copyObj) ? [] : {};
      if (typeof newObj !== 'object') {
        return false;
      }
      for (const i in copyObj) {
        if (Object.hasOwnProperty.call(copyObj, i)) {
          const value = copyObj[i];
          newObj[i] =
            typeof value === 'object' ? this.deepCopyObj(value) : value;
        }
      }
      return newObj;
    },
  },
  watch: {
    $route(newRoute) {
      const { name, query, params, meta } = newRoute;
      this.currentPageTitle = meta.title;
      if (
        name == 'paymentOrderOutsideTwo/out' ||
        name == 'paymentOrderTwo/inner'
      ) {
        if (this.userInfo.orgtype === '培才')
          this.currentPageTitle = '付款通知单(培才)';
        else this.currentPageTitle = '付款通知单(CJ)';
      }

      this.addTag({
        route: { name, query, params, meta },
        type: 'push',
      });
      this.setBreadCrumb(newRoute);
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute));
      this.$refs.sideMenu.updateOpenName(newRoute.name);
    },
  },
};
</script>
<style scoped lang="less">
.black-text {
  color: #2d2d30;
}
.customer-service {
  position: fixed;
  display: block;
  position: fixed;
  padding: 5px 10px;
  right: 0px;
  bottom: 20px;
  z-index: 10;
  background: #1e68bd;
  border: 2px solid #fff;
  border-radius: 8px 0 0 8px;
  text-align: center;
  -webkit-box-shadow: 1px 3px 7px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 1px 3px 7px 0 rgba(0, 0, 0, 0.5);
  color: #ffffff;
  cursor: pointer;
  &:hover {
    transition: 600ms;
    transform: scale(1.2);
  }
  img {
    width: 24px;
  }
}
.service-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  .service-title {
    font-size: 24px;
    color: #515a61;
    line-height: 24px;
    margin: 16px;
  }
  img {
    width: 200px;
    height: 200px;
  }
}
.menu-title {
  width: 250px;
}

.msg-box {
  border: 1px solid #eee;
  border-radius: 10px;
  margin-top: 20px;
  padding: 10px;
  &:first-child {
    margin-top: unset;
  }
  div {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: normal;
    text-align: left;
    display: flex;
    margin-top: 12px;
    align-items: center;
    &:first-child {
      margin-top: 20px;
    }
    span {
      display: block;
      width: 70px;
    }
  }
}

.msg-box:hover {
  cursor: pointer;
}

strong {
  font-weight: bold;
}

.menu-title {
  width: 250px;
}

::v-deep .ivu-menu-vertical {
  margin-top: 177px !important;
}
::v-deep .ivu-badge-dot {
  top: 21px !important;
  right: -4px !important;
}

::v-deep .ivu-table-overflowY {
  overflow-x: scroll !important;
}

strong {
  color: #333333;
  line-height: normal;
}
::v-deep .ivu-time {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: normal;
}
::v-deep .ivu-badge-count {
  top: 0 !important;
  right: 6px;
}
</style>
